export default __webpack_public_path__ + "static/media/icon_edit_s.fd222f79.svg";